window.Products.Bag.MarketTote = function() {};
window.Products.Bag.MarketTote.inherits(window.Products.Bag.Bag);
window.Products.Bag.MarketTote.id = 95;
window.Products.Bag.MarketTote.slug = 'market-tote';
window.Products.Bag.MarketTote.has_3d = true;
window.Products.Bag.MarketTote.use_glb = true;
window.Products.Bag.MarketTote.rotate_fit = true;
window.Products.Bag.MarketTote.fit_template_all = true;
window.Products.Bag.MarketTote.dpi = 150;

window.Products.Bag.MarketTote.prototype.set3dProperties = function(modelViewer) {
	var me = this;

	modelViewer.object.position.y = -0.05;

	me.loadEnvMap(function(){
		for(var i = 0; i < modelViewer.object.children.length; i++){
			if(!modelViewer.object.children[i].material) continue;
			modelViewer.object.children[i].material.aoMapIntensity = 2;
			modelViewer.object.children[i].material.envMap = me.envMap;
			modelViewer.object.children[i].material.envMap.mapping = THREE.EquirectangularReflectionMapping;
			modelViewer.object.children[i].material.needsUpdate = true;
			modelViewer.object.children[i].material.envMap.needsUpdate = true;
			if(modelViewer.object.children[i].material.normalMap) {
				modelViewer.object.children[i].material.normalScale.x = 0.2;
				modelViewer.object.children[i].material.normalScale.y = -0.2;
			}
		}
		me.updateThreeTexture(modelViewer);
	});

	me.setStrap('935', modelViewer);
};

window.Products.Bag.MarketTote.prototype.setThreeControls = function(controls) {
	controls.minDistance = 1.8;
	controls.maxDistance = 3.0;
};

window.Products.Bag.MarketTote.prototype.isLined = function(modelViewer) {
	return ["938", "940"].indexOf($('#productInfo-productOption-style').find(':selected').attr('value')) == "-1";
};

window.Products.Bag.MarketTote.prototype.updateThreeTexture = function(modelViewer) {
	var me = this, index = 2;

	if(!me.isLined(modelViewer)) index = 1;

	modelViewer.object.children[index].material.map = modelViewer.texture;
	modelViewer.object.children[index].material.map.flipY = false;
	modelViewer.object.children[index].material.needsUpdate = true;
};

window.Products.Bag.MarketTote.prototype.setLining = function(modelViewer) {
	var me = this, o = modelViewer.object;
	
	var suffix = me.isLined(modelViewer) ? '' : '-basic';

	modelViewer.loadModel(this, 'none', suffix);
};

window.Products.Bag.MarketTote.prototype.setStrap = function(type, modelViewer) {
	var me = this, o = modelViewer.object;
	return;
	switch(type) {
		case '935': // Cotton, Natural
			o.children[3].material.color.r = 1.00;
			o.children[3].material.color.g = 0.97;
			o.children[3].material.color.b = 0.89;
			break;
		case '936': // Cotton, Black
			o.children[3].material.color.r = 0.20;
			o.children[3].material.color.g = 0.22;
			o.children[3].material.color.b = 0.22;
			break;
	}
};